import type { ReactNode } from 'react';

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
      {icon ? <div className="text-fg-subtle">{icon}</div> : null}
      <div className="text-fg text-base font-medium">{title}</div>
      {description ? <div className="text-fg-muted max-w-md text-sm">{description}</div> : null}
      {action}
    </div>
  );
}
